import I18n from 'I18n';
import { DateFilterType } from '../constants/filters';
const DATE_FORMAT = 'll';
const formatDateRange = (start, end) => {
  return `${start.format(DATE_FORMAT)} – ${end.format(DATE_FORMAT)}`;
};
const formatSingleDate = date => {
  return date.format(DATE_FORMAT);
};
export const getDateRangeDescription = type => {
  switch (type) {
    case DateFilterType.TODAY:
      return formatSingleDate(I18n.moment.userTz());
    case DateFilterType.YESTERDAY:
      return formatSingleDate(I18n.moment.userTz().subtract(1, 'day'));
    case DateFilterType.LAST_7_DAYS:
      return formatDateRange(I18n.moment.userTz().subtract(7, 'days').startOf('day'), I18n.moment.userTz());
    case DateFilterType.LAST_30_DAYS:
      return formatDateRange(I18n.moment.userTz().subtract(30, 'days').startOf('day'), I18n.moment.userTz());
    case DateFilterType.THIS_WEEK:
      return formatDateRange(I18n.moment.userTz().startOf('week'), I18n.moment.userTz());
    case DateFilterType.THIS_MONTH:
      return formatDateRange(I18n.moment.userTz().startOf('month'), I18n.moment.userTz().endOf('month'));
    case DateFilterType.LAST_MONTH:
      return formatDateRange(I18n.moment.userTz().subtract(1, 'month').startOf('month'), I18n.moment.userTz().subtract(1, 'month').endOf('month'));
    case DateFilterType.THIS_QUARTER:
      return formatDateRange(I18n.moment.userTz().startOf('quarter'), I18n.moment.userTz().endOf('quarter'));
    case DateFilterType.LAST_QUARTER:
      return formatDateRange(I18n.moment.userTz().subtract(1, 'quarter').startOf('quarter'), I18n.moment.userTz().subtract(1, 'quarter').endOf('quarter'));
    case DateFilterType.YEAR_TO_DATE:
      return formatDateRange(I18n.moment.userTz().startOf('year'), I18n.moment.userTz());
    case DateFilterType.ALL_TIME:
      return undefined;
    default:
      return undefined;
  }
};